import { IntegratedPaging, IntegratedSorting, PagingState, SortingState } from '@devexpress/dx-react-grid';
import {
  DragDropProvider,
  Grid as TableGrid,
  PagingPanel,
  Table,
  TableColumnReordering,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { Button, Chip, Grid, TableCell, TextField } from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import {
  CheckCircle as SuccessIcon,
  Close as CloseIcon,
  CloudDownload as CloudDownloadIcon,
  Error as ErrorIcon,
  Info as InfoIcon,
  Search as SearchIcon,
} from '@material-ui/icons';
import * as axios from 'axios';
import { Avatar, IconButton, InputAdornment, LinearProgress, Paper, Snackbar } from 'material-ui';
import { SnackbarContent } from 'material-ui/Snackbar';
import { withStyles } from 'material-ui/styles';

import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import getMyActivity from '../../actions/getMyActivity';
import postCreatePresignedUrl from '../../actions/postCreatePresignedUrl';
import search from '../../actions/search';
import compareCaseInsensitive from '../../helpers/CompareCaseInsensitive';
import optional from '../../helpers/OptionalAccess';
import Layout from '../Layout';
import MyActivityReportMenu from './MyActivityReportMenu';
import {
  writeHTMLToNewWindow,
  formatJson,
  highlightSyntaxJson,
  exportRaw, displayJsonTemplate,
} from '../../helpers/ReportHistoryHelper';
import { last } from 'lodash';


const snackIcons = {
  error: ErrorIcon,
  info: InfoIcon,
  success: SuccessIcon,
};

const styles = theme => ({
  paper: {
    width: '80%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '6vh',
  },
  searchForm: {
    width: '100%',
    padding: theme.spacing.unit * 3,
  },
  textField: {
    width: 350,
  },
  selectTableCell: {
    paddingLeft: '0 !important',
  },
  inputRoot: {
    width: '100%',
  },
  selectMenuItem: {
    justifyContent: 'space-between !important',
  },
  linearProgress: {
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
  },
  chip: {
    margin: '24px 0 0',
  },
  snack: {
    top: '16px',
  },
  snackContent: {
    background: '#d32f2f',
    color: '#fff',
  },
  snackMessage: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    padding: 4,
  },
  error: {
    background: theme.palette.error.dark,
    color: '#fff',
  },
  info: {
    background: theme.palette.primary.dark,
    color: '#fff',
  },
  success: {
    background: green[600],
    color: '#fff',
  },
});

const getRowId = row => row.id;

const sortByDate = (a, b) => {
  const dateA = moment(a);
  const dateB = moment(b);
  if (dateA === dateB) {
    return 0;
  }

  return (dateA < dateB) ? -1 : 1;
};


class MyActivity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downloadingReport: false,
      error: false,
      loading: false,
      snackMessage: false,
      snackVariant: 'error',
      vin: '',
      rows: [],
      persons: [],
      columns: [
        { name: 'date', title: 'Date' },
        { name: 'vinCount', title: 'VIN Count' },
        { name: 'name', title: 'User' },
        { name: 'reports', title: 'Reports' },
      ],
      columnOrder: ['date', 'vinCount', 'name', 'reports'],
      tableColumnExtensions: [],
      sorting: [{ columnName: 'date', direction: 'desc' }],
      sortingIntegratedExtensions: [
        { columnName: 'date', compare: sortByDate },
        { columnName: 'name', compare: compareCaseInsensitive },
      ],
      sortingStateExtensions: [{ columnName: 'reports', sortingEnabled: false }],
      currentPage: 0,
      pageSize: 5,
      pageSizes: [5, 10, 0],
    };
  }

  componentDidMount() {
    const { vin } = this.state;
    const { actions } = this.props;

    this.setState({
      loading: true,
      snackMessage: 'Loading user data...',
      snackVariant: 'info',
    });

    actions.getPersons(this)
      .then(() => {
        this.queryMyActivity({ vin });
      });
  }

  CellComponent = (cellProps) => {
    const { classes } = this.props;
    const { column, row, value } = cellProps;
    const rowId = getRowId(row);

    if (column.name === 'reports') {
      return (
        <TableCell className={classes.selectTableCell}>
          <MyActivityReportMenu
            id={rowId}
            reports={value}
            handleViewCsv={this.showReportCsv}
            handleViewHtml={this.showReportHtml}
            handleViewJson={this.showReportJson}
          />
        </TableCell>
      );
    }

    return <Table.Cell {...cellProps} />;
  };

  changeCurrentPage = currentPage => this.setState({ currentPage });

  changeColumnOrder = columnOrder => this.setState({ columnOrder });

  changePageSize = pageSize => this.setState({ pageSize });

  changeSorting = sorting => this.setState({ sorting });

  closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ snackMessage: false });
  };

  clearSearch = () => {
    this.setState({
      loading: true,
      rows: [],
      snackMessage: false,
      vin: ''
    });

    this.queryMyActivity({ vin: '' });
  };

  handleKeyPress = (event) => {
    // enter key was pressed
    if (event.keyCode === 13) {
      this.handleSearch(event);
    }
  }

  handleSearch = (event) => {
    if (event) event.preventDefault();
    const { vin } = this.state;

    this.setState({
      loading: true,
      rows: [],
      snackMessage: false
    });

    this.queryMyActivity({ vin });
  };

  getPersonById = (personId, defaultValue) => {
    const { persons } = this.state;

    if (!persons || !personId) {
      return defaultValue || 'Unknown';
    }

    const person = persons.find(p => p.personId === personId);
    if (!person) {
      return defaultValue || 'Unknown';
    }

    if (!person.firstName || !person.lastName) {
      return defaultValue || 'Unknown';
    }

    return `${person.firstName} ${person.lastName}`;
  };

  mapRequestItem = (item) => {
    const {
      requestId,
      timestamp,
      vinCount = 1,
      personId,
      customerName,
      reports
    } = item;

    const sortedReports = Object
      .keys(reports)
      .map((key) => ({
        bucket: reports[key].bucket,
        requestId: reports[key].requestId,
        reportType: reports[key].reportType,
        htmlKey: reports[key].htmlKey,
        csvKey: reports[key].csvKey,
      }))
      .sort((a, b) => {
        // sort reports in alpha order
        const nameA = a.reportType.toLowerCase();
        const nameB = b.reportType.toLowerCase();

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;

        return 0;
      });

    return {
      id: requestId,
      date: moment(timestamp).local().format('MM/DD/YYYY hh:mm A Z'),
      vinCount: parseInt(vinCount, 10),
      name: this.getPersonById(personId, customerName),
      reports: sortedReports,
    };
  };

  queryMyActivity = async ({ vin }) => {
    const { actions, data } = this.props;
    const { config } = data;

    const customerId = localStorage.getItem('customerId');
    this.setState({
      snackMessage: 'Searching customer report activity...',
      snackVariant: 'info',
    });

    let lastEvaluatedKey = '';

    lastEvaluatedKey = await this.searchMyActivityFn(actions, customerId, vin, config, lastEvaluatedKey);

    while (lastEvaluatedKey) {
      lastEvaluatedKey = await this.searchMyActivityFn(actions, customerId, vin, config, lastEvaluatedKey);
    }
  };

  searchMyActivityFn = async (actions, customerId, vin, config, lastEvaluatedKey) => {
    let lastEvalVal = '';
    await actions
      .searchMyActivity({ customerId, vin, config, lastEvaluatedKey })
      .then((response) => {
        const data = optional(response, ['value', 'data'], undefined);
        const { items } = data;

        const itemval = items.filter(val => (!['RISK_SCORE', 'RISK_PLUS', 'NVMTIS', 'VEHICLE_HISTORY'].some(k => k in val.reports)));

        lastEvalVal = data.lastEvaluatedKey;

        this.setState({
          rows: [...this.state.rows, ...itemval.map(this.mapRequestItem)],
          snackMessage: false,
        });

        if (!lastEvalVal) {
          this.setState({
            loading: false,
            snackMessage: 'Search finished successfully!',
            snackVariant: 'success',
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          snackMessage: 'There was an error completing the query!',
          snackVariant: 'error',
          loading: false
        });
      });
      return lastEvalVal;
  }

  showReportHtml = (selectedReport) => {
    const { actions, data: { config } } = this.props;

    actions.showSelectedReport(selectedReport, 'html', config, this);
  };

  showReportJson = (selectedReport) => {
    const { actions, data: { config } } = this.props;

    actions.showSelectedReport(selectedReport, 'json', config, this);
  }

  showReportCsv = (selectedReport) => {
    const { actions, data: { config } } = this.props;

    actions.showSelectedReport(selectedReport, 'csv', config, this);
  }

  render() {
    const { classes } = this.props;
    const {
      columns,
      columnOrder,
      currentPage,
      downloadingReport,
      snackMessage,
      snackVariant,
      loading,
      pageSize,
      pageSizes,
      rows,
      sorting,
      sortingIntegratedExtensions,
      sortingStateExtensions,
      tableColumnExtensions,
    } = this.state;

    const SnackIcon = snackIcons[snackVariant];


    return (
      <Layout
        className="App"
        showMenu
        toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
      >
        {Boolean(loading || downloadingReport) && <LinearProgress className={classes.linearProgress} />}
        {
          Boolean(downloadingReport) && (
            <React.Fragment>
              <div className={classes.downloadIndicator}>
                <Chip
                  avatar={
                    <Avatar>
                      <CloudDownloadIcon />
                    </Avatar>
                  }
                  label={`Retrieving ${downloadingReport} report...`}
                  className={classes.chip}
                  color="primary"
                />
              </div>
            </React.Fragment>
          )
        }
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          autoHideDuration={5000}
          open={Boolean(snackMessage) !== false}
          className={classes.snack}
          onClose={this.closeSnackbar}
        >
          <SnackbarContent
            className={classes[snackVariant]}
            message={
              <span className={classes.snackMessage}>
                <SnackIcon style={{ marginRight: 4 }} /> {snackMessage}
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.snackClose}
                onClick={this.closeSnackbar}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </Snackbar>
        <Paper className={classes.paper}>
          <Grid spacing={16} container alignItems="flex-end" justify="center" className={classes.searchForm}>
            <Grid item xs={3}>
              <TextField
                name="vin"
                label="Search by VIN"
                fullWidth
                className={classes.textField}
                disabled={loading}
                onChange={event => this.setState({ vin: event.target.value })}
                onKeyDown={this.handleKeyPress}
                value={this.state.vin}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                color="primary"
                variant="contained"
                onClick={(event) => {
                  this.handleSearch(event);
                }}
                style={{ marginRight: 16 }}
              >
                Search
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  this.clearSearch();
                }}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
          <TableGrid
            rows={rows}
            columns={columns}
            getRowId={getRowId}
          >
            <SortingState
              sorting={sorting}
              onSortingChange={this.changeSorting}
              columnExtensions={sortingStateExtensions}
            />
            <PagingState
              currentPage={currentPage}
              pageSize={pageSize}
              onCurrentPageChange={this.changeCurrentPage}
              onPageSizeChange={this.changePageSize}
            />

            <IntegratedSorting
              columnExtensions={sortingIntegratedExtensions}
            />
            <IntegratedPaging />

            <DragDropProvider />

            <Table
              columnExtensions={tableColumnExtensions}
              cellComponent={this.CellComponent}
            />

            <TableColumnReordering
              order={columnOrder}
              onOrderChange={this.changeColumnOrder}
            />

            <TableHeaderRow showSortingControls />
            <PagingPanel pageSizes={pageSizes} />
          </TableGrid>
        </Paper>
      </Layout>
    );
  }
}

const mapStateToProps = state => (
  {
    data: {
      config: state.config.config,
      person: state.person.person,

      persons: optional(state, ['search', 'persons', 'data'], []),
    },
  }
);

const mapDispatchToProps = dispatch => (
  {
    actions: {
      getPersons: (self) => {
        const { persons, config } = self.props.data;
        if (persons && persons.length) {
          self.setState({ persons });
        };

        return dispatch(search('persons', 0, undefined, config))
          .then((result) => {
            const { items: persons } = result.value.data;
            self.setState({ persons });
          })
          .catch((error) => {
            self.setState({
              snackMessage: 'Error retrieving users!',
              snackVariant: 'error',
            });
            console.error(error);
          });
      },
      searchMyActivity: async ({ customerId, vin, config, lastEvaluatedKey }) => {
        const params = {
          customerId,
          vin,
          lastEvaluatedKey
        };

        return dispatch(getMyActivity(params, config));
      },
      showSelectedReport: (selectedReport, format, config, self) => {
        const { bucket, reportType } = selectedReport;
        let key = selectedReport.htmlKey;

        if (format === 'csv') {
          key = selectedReport.csvKey;
        }

        self.setState({ downloadingReport: reportType, snackMessage: false });

        dispatch(postCreatePresignedUrl(bucket, key, 'get', config))
          .then((result) => {
            const { preSignedUrl } = result.value.data;
            axios({ method: 'get', url: preSignedUrl })
              .then((response) => {
                self.setState({ downloadingReport: false });

                if (format === 'json') {
                  const json = highlightSyntaxJson(formatJson(response.data));
                  const html = displayJsonTemplate
                    .replace('{reportType}', reportType)
                    .replace('{json}', json);

                  writeHTMLToNewWindow(reportType, html);
                } else if (format === 'html') {
                  writeHTMLToNewWindow(reportType, response.data);
                } else {
                  exportRaw(reportType, response.data);
                }
              })
              .catch((error) => {
                self.setState({
                  downloadingReport: false,
                  snackMessage: 'There was an error downloading the report!',
                  snackVariant: 'error',
                  loading: false,
                });
                console.error(error);
              });
          })
          .catch((error) => {
            this.setState({
              downloadingReport: false,
              snackMessage: 'There was an error downloading the report!',
              snackVariant: 'error',
              loading: false,
            });
            console.error(error);
          });
      },
    },
  }
);

const ConnectedMyActivity = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MyActivity);

export default withStyles(styles, { name: 'MyActivity' })(ConnectedMyActivity);


// WEBPACK FOOTER //
// ./src/components/Account/MyActivity.js